module.exports = __webpack_public_path__ + "static/media/YM18_0.3f35d670.jpg";